import { allFilters } from "./definitions";
import { Filters } from "./Filters";

const topFiltersPP = [allFilters.mailId, allFilters.accountNumber, allFilters.receiveDate];
const topFiltersRE = [allFilters.mailId, allFilters.parcelNumber, allFilters.receiveDate];
const bottomFilters = [
    allFilters.state,
    allFilters.jurisdiction,
    allFilters.assignedTo,
    allFilters.status,
];

export const filtersByMailType = {
    "tax-bill-personal": (
        <Filters
            resetButton={true}
            filters={[
                ...topFiltersPP,
                allFilters.earliestPaymentDueDate,
                allFilters.trueAmountDue,
                ...bottomFilters,
            ]}
        />
    ),
    "tax-return-personal": (
        <Filters
            resetButton={true}
            filters={[...topFiltersPP, allFilters.filingDueDate, ...bottomFilters]}
        />
    ),
    "value-notice-personal": (
        <Filters
            resetButton={true}
            filters={[...topFiltersPP, allFilters.appealDeadline, ...bottomFilters]}
        />
    ),
    "hearing-notice-personal": (
        <Filters
            resetButton={true}
            filters={[...topFiltersPP, allFilters.dateOfHearing, ...bottomFilters]}
        />
    ),
    "check-personal": <Filters resetButton={true} filters={[...topFiltersPP, ...bottomFilters]} />,
    "tax-bill-real": (
        <Filters
            resetButton={true}
            filters={[
                ...topFiltersRE,
                allFilters.earliestPaymentDueDate,
                allFilters.totalTaxesOwed,
                ...bottomFilters,
            ]}
        />
    ),
    "value-notice-real": (
        <Filters
            resetButton={true}
            filters={[
                ...topFiltersRE,
                allFilters.taxBillEstimate,
                allFilters.appealDeadline,
                ...bottomFilters,
            ]}
        />
    ),
    "hearing-notice-real": (
        <Filters
            resetButton={true}
            filters={[...topFiltersRE, allFilters.dateOfHearing, ...bottomFilters]}
        />
    ),
    "check-real": (
        <Filters
            resetButton={true}
            filters={[...topFiltersRE, allFilters.checkNumber, ...bottomFilters]}
        />
    ),
    "common-filters": (
        <Filters
            resetButton={true}
            filters={[
                allFilters.mailId,
                allFilters.receiveDate,
                allFilters.dueDate,
                allFilters.assignedDate,
                allFilters.updatedOn,
                allFilters.status,
            ]}
        />
    ),
    "calender-event": (
        <Filters
            resetButton={true}
            filters={[
                allFilters.mailId,
                allFilters.receiveDate,
                allFilters.dueDate,
                allFilters.assignedTo,
                allFilters.assignedDate,
                allFilters.status,
            ]}
        />
    ),
    miscellaneous: (
        <Filters
            filters={[
                allFilters.mailId,
                allFilters.receiveDate,
                allFilters.assignedTo,
                allFilters.status,
            ]}
        />
    ),
    parcel: <Filters filters={[allFilters.parcelNumber, allFilters.address, allFilters.status]} />,
    property: (
        <Filters filters={[allFilters.propertyNumber, allFilters.address, allFilters.status]} />
    ),
    "audit-records-mails": (
        <Filters
            filters={[
                allFilters.fileName,
                allFilters.fileType,
                allFilters.fileSizeInMB,
                allFilters.status,
            ]}
        />
    ),
    "audit-records-data-source-files": (
        <Filters
            filters={[
                allFilters.fileName,
                allFilters.dataType,
                allFilters.fileSizeInMB,
                allFilters.status,
            ]}
        />
    ),
};
